import { render, staticRenderFns } from "./PlacementsStartComponentDevelopmentItem.vue?vue&type=template&id=5a86b7a6&"
import script from "./PlacementsStartComponentDevelopmentItem.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentDevelopmentItem.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentDevelopmentItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports